import React from "react";

export default function AppLayout({ children }) {
  return (
    <div>
      {children}
    </div>
  );
}
